import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReduceMotionService {
  private readonly STORAGE_KEY = 'reduceMotionPreference';
  private mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
  private reduceMotionSubject: BehaviorSubject<boolean>;

  public reduceMotion$: Observable<boolean>;

  constructor() {
    // initialize with stored preference or system preference
    const storedPreference = this.getStoredPreference();
    const initialValue = storedPreference !== null
      ? storedPreference
      : this.mediaQuery.matches;

    // emit the motion preference
    this.reduceMotionSubject = new BehaviorSubject<boolean>(initialValue);
    this.reduceMotion$ = this.reduceMotionSubject.asObservable();
    // set the class on the body
    if (initialValue) {
      document.body.classList.add('reduce-motion');
    }

    // Only listen to system changes if there's no stored preference
    this.mediaQuery.addEventListener('change', (event) => {
      if (this.getStoredPreference() === null) {
        this.reduceMotionSubject.next(event.matches);
      }
    });
  }

  private getStoredPreference(): boolean | null {
    const stored = localStorage.getItem(this.STORAGE_KEY);
    return stored !== null ? JSON.parse(stored) : null;
  }

  setReduceMotion(reduce: boolean) {
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(reduce));

    if (reduce) {
      document.body.classList.add('reduce-motion');
    } else {
      document.body.classList.remove('reduce-motion');
    }

    this.reduceMotionSubject.next(reduce);
  }
}
